import api from "utils/api";

// 서버가 기대하는 경로 파라미터: lessons / travel-products / products
// 다양한 입력 값(예: "PRODUCT", "lesson", "travel")을 경로 파라미터로 정규화한다.
const PRODUCT_TYPE_MAP = {
    product: "products",
    products: "products",
    lesson: "lessons",
    lessons: "lessons",
    travel: "travel-products",
    "travel-product": "travel-products",
    "travel-products": "travel-products",
    travelproduct: "travel-products",
    travelproducts: "travel-products",
};

export const normalizeProductType = (type) => {
    if (!type) return null;
    const key = String(type).toLowerCase().trim();
    return PRODUCT_TYPE_MAP[key] || null;
};

// 리뷰 생성 (multipart/form-data로 이미지/동영상 포함)
// 서버 엔드포인트: POST /buccl_main/api/v1/{product_type}/{product_id}/reviews/create/
export const createReview = async ({
    product_type,
    product_id,
    rating,
    content,
    images = [],
    videos = [],
}) => {
    const productType = normalizeProductType(product_type);
    if (!productType) {
        throw new Error(`유효하지 않은 product_type: ${product_type}`);
    }
    if (!product_id) {
        throw new Error("product_id가 누락되었습니다.");
    }

    const formData = new FormData();
    formData.append("rating", rating);
    formData.append("content", content);
    images.forEach((file) => formData.append("images", file));
    videos.forEach((file) => formData.append("videos", file));

    const res = await api.post(
        `/buccl_main/api/v1/${productType}/${product_id}/reviews/create/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
    );
    return res.data;
};

// 특정 상품 리뷰 목록
// productType: lessons / travel-products / products
export const getProductReviews = async (productType, productId) => {
    const normalized = normalizeProductType(productType);
    const res = await api.get(
        `/buccl_main/api/v1/${normalized || productType}/${productId}/reviews/`
    );
    return res.data;
};

// 내 리뷰 목록
export const getMyReviews = async (params = {}) => {
    const res = await api.get("/buccl_main/api/v1/reviews/my/", { params });
    return res.data;
};

// 리뷰 상세
export const getReviewDetail = async (reviewId) => {
    const res = await api.get(`/buccl_main/api/v1/reviews/${reviewId}/`);
    return res.data;
};

// 리뷰 수정
export const updateReview = async (reviewId, reviewData) => {
    const formData = new FormData();
    formData.append("rating", reviewData.rating);
    formData.append("content", reviewData.content);
    if (reviewData.images) {
        reviewData.images.forEach((file) => {
            formData.append("images", file);
        });
    }
    if (reviewData.videos) {
        reviewData.videos.forEach((file) => {
            formData.append("videos", file);
        });
    }
    if (reviewData.existing_images) {
        reviewData.existing_images.forEach((url) => {
            formData.append("existing_images", url);
        });
    }
    const res = await api.put(
        `/buccl_main/api/v1/reviews/${reviewId}/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
    );
    return res.data;
};

// 리뷰 삭제
export const deleteReview = async (reviewId) => {
    const res = await api.delete(`/buccl_main/api/v1/reviews/${reviewId}/`);
    return res.data;
};
